<div matDialogTitle>{{ data.title }}</div>
<mat-dialog-content>
  <p>{{ data.text() }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.closable) {
    <button mat-dialog-close matButton="elevated">Close</button>
  }
</mat-dialog-actions>